import * as Yup from 'yup';

import { translate } from '@utils';

export const getValidationSchema = () => {
  return Yup.string().required(
    translate('subModules/creditScore:validation.required')
  );
};
